import React from 'react';
import { Box, Skeleton } from '@mui/material';

const SkeletonLoader = ({ rows = 5 }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
    {Array.from({ length: rows }).map((_, i) => (
      <Box key={i} sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Skeleton variant="rectangular" width={64} height={40} />
        <Box sx={{ flex: 1 }}>
          <Skeleton width="60%" />
          <Skeleton width="40%" />
        </Box>
        <Skeleton width={80} />
      </Box>
    ))}
  </Box>
);

export default SkeletonLoader;
